import * as svg from "../../../assets/pause-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const PauseIcon = iconBuilder(svg, "PauseIcon", "0 0 16 16");
